import { DateTime } from 'luxon';

export const futureDate = (duration: number, units: string): Date => {
	return DateTime.local()
		.plus({ [units]: duration })
		.toJSDate();
};
